export default __webpack_public_path__ + "static/media/IBMPlexSans-Italic-Latin1.d7933029.woff2";